var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D25E6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6151 16.392V14.3636H22.1719V16.392H18.6094V26H16.1776V16.392H12.6151ZM28.3423 17.2727V19.0909H23.0866V17.2727H28.3423ZM24.2798 15.1818H26.7003V23.3182C26.7003 23.5417 26.7344 23.7159 26.8026 23.8409C26.8707 23.9621 26.9654 24.0473 27.0866 24.0966C27.2116 24.1458 27.3556 24.1705 27.5185 24.1705C27.6321 24.1705 27.7457 24.161 27.8594 24.142C27.973 24.1193 28.0601 24.1023 28.1207 24.0909L28.5014 25.892C28.3802 25.9299 28.2098 25.9735 27.9901 26.0227C27.7704 26.0758 27.5033 26.108 27.1889 26.1193C26.6056 26.142 26.0942 26.0644 25.6548 25.8864C25.2192 25.7083 24.8802 25.4318 24.6378 25.0568C24.3954 24.6818 24.276 24.2083 24.2798 23.6364V15.1818Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.0613d416.svg";
export { ForwardRef as ReactComponent };